/* istanbul ignore file */
import { Component, input, InputSignal, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CardMode } from '@components/card/card.component';
import { MdsTextFieldComponent } from '@medpacesoftwaredevelopment/designsystem';
import { PersistentFormGroup } from '@utility/persistent-forms';
import { FormGroupValueOf } from '@utility/utility';
import { maxLengthValidator, notWhitespaceValidator } from '@utility/utility.validators';
export class LodgingPreferencesFormGroup extends PersistentFormGroup<{
    hotelBrandPreference: FormControl<string>;
    roomPreference: FormControl<string>;
    specialNeeds: FormControl<string>;
    allergies: FormControl<string>;
}> {
    public static create(value: FormGroupValueOf<LodgingPreferencesFormGroup>): LodgingPreferencesFormGroup {
        return new LodgingPreferencesFormGroup({
            hotelBrandPreference: new FormControl(value.hotelBrandPreference, [
                notWhitespaceValidator(),
                maxLengthValidator(50),
            ]),
            roomPreference: new FormControl(value.roomPreference, [notWhitespaceValidator(), maxLengthValidator(500)]),
            specialNeeds: new FormControl(value.specialNeeds, [notWhitespaceValidator(), maxLengthValidator(500)]),
            allergies: new FormControl(value.allergies, [notWhitespaceValidator(), maxLengthValidator(1000)]),
        });
    }
}
@Component({
    selector: 'medpace-lodging-preferences',
    templateUrl: './lodging-preferences.component.html',
    styleUrls: ['./lodging-preferences.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MdsTextFieldComponent],
})
export class LodgingPreferencesComponent {
    public readonly formGroup: InputSignal<LodgingPreferencesFormGroup> = input.required<LodgingPreferencesFormGroup>();
    public readonly mode: InputSignal<CardMode> = input.required<CardMode>();
}
